import { supabase } from "@/integrations/supabase/client";
import { UnmatchedEmail } from "@/types/unmatchedEmails";
import { toEdgeFunctionFailure } from "@/utils/userFacingError";

async function invoke<T>(body: Record<string, unknown>): Promise<T> {
  const { data, error } = await supabase.functions.invoke("admin-unmatched-emails-api", {
    method: "POST",
    body,
  });
  if (error) throw await toEdgeFunctionFailure(error, "Unknown error");
  return data as T;
}

export class UnmatchedEmailsApiClient {
  static async list(): Promise<UnmatchedEmail[]> {
    const data = await invoke<{ emails: UnmatchedEmail[] }>({ action: "list" });
    return data.emails;
  }

  static async assign(id: string, companyId: string): Promise<string[]> {
    const data = await invoke<{ success: boolean; documentIds: string[] }>({
      action: "assign",
      id,
      companyId,
    });
    return data.documentIds;
  }

  static async dismiss(id: string): Promise<void> {
    await invoke<{ success: boolean }>({ action: "dismiss", id });
  }
}
